import { render, staticRenderFns } from "./StarLogo.vue?vue&type=template&id=06b38bd8&scoped=true&"
import script from "./StarLogo.vue?vue&type=script&lang=js&"
export * from "./StarLogo.vue?vue&type=script&lang=js&"
import style0 from "./StarLogo.vue?vue&type=style&index=0&id=06b38bd8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b38bd8",
  null
  
)

export default component.exports